module.exports = __webpack_public_path__ + "img/wage_example_fr.4f58a153.jpg";